import { Box, Paper } from '@mui/material';
import { Frame } from '@craftjs/core';
import React from 'react';
import '@descope/page-editor-components/dist/style.css';
import checkerboard from '@components/checkerboard';
import Wrapper from './Wrapper';

type Props = {
	width: number;
	height: number;
};

const Canvas: React.FC<Props> = ({ width, height }) => (
	<Wrapper height="100%">
		<Paper
			className="page-container"
			sx={{
				height: '100%',
				borderRadius: 0,
				padding: 2,
				background: checkerboard,
				overflow: 'scroll',
				display: 'flex',
				'& > *': { margin: 'auto' },
				'#ROOT': {
					margin: 'auto',
					flexShrink: 0
				}
			}}
		>
			<Box
				data-testid="canvas-resize"
				sx={{
					width: width ? `${width}px` : '100%',
					height: height ? `${height}px` : '100%',
					boxShadow: (height || width) && '0px 0px 38px 9999px #00000060',
					display: 'flex',
					alignItems: 'center',
					border: (height || width) && '1px solid gray',
					overflow: 'scroll',
					flexShrink: 0
				}}
			>
				<Frame />
			</Box>
		</Paper>
	</Wrapper>
);

export default Canvas;
